import { Link } from 'react-router-dom';
import { FiCompass } from 'react-icons/fi';

/**
 * Persistent, non-dismissible strip shown while touring as a guest. Reminds the visitor
 * that nothing is saved until they create an account, and offers the conversion CTA.
 */
export default function GuestBanner() {
  return (
    <div className="bg-primary/10 border-b border-primary/20 px-4 py-2 text-sm flex items-center gap-3">
      <FiCompass className="text-primary shrink-0" />
      <span className="flex-1 min-w-0 text-base-content/80">
        You&apos;re exploring as a guest — create a free account to keep your progress.
      </span>
      <Link to="/register" className="btn btn-primary btn-xs shrink-0">
        Sign up
      </Link>
    </div>
  );
}
